import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import getSecuredStatementPdf from "../services/getSecuredStatementPdf";
import endPoints from "../const/endpoints";
import useNavigateToStatement from "./useNavigateToStatement";
var useRequestStatementPdfMutation = function (params) {
    var errorCount = (params || {}).errorCount;
    var queryClient = useQueryClient();
    var location = useLocation();
    var navigateToStatement = useNavigateToStatement();
    return useMutation({
        mutationFn: getSecuredStatementPdf,
        onSuccess: function (data, _a) {
            var accountId = _a.accountId, statementDate = _a.statementDate, statementInsert = _a.statementInsert;
            queryClient.setQueryData([
                endPoints.statementsUrl,
                { accountId: accountId, statementDate: statementDate, statementInsert: statementInsert },
            ], data.data);
            if (errorCount) {
                errorCount.current = 0;
            }
            if (!location.pathname.includes("/statement")) {
                navigateToStatement({ statementDate: statementDate, statementInsert: statementInsert });
            }
        },
        onError: function (_, _a) {
            var statementDate = _a.statementDate, statementInsert = _a.statementInsert;
            if (errorCount) {
                errorCount.current += 1;
                if (errorCount.current > 2) {
                    // navigate to statement page which will handle showing an error
                    navigateToStatement({ statementDate: statementDate, statementInsert: statementInsert });
                }
            }
        },
    });
};
export default useRequestStatementPdfMutation;
